import { useContext, useEffect, useState } from "react";
import { AppContext } from "../App";
import { getInlineLoader } from "../Helpers";

import Footer from "../ones/Footer";
import StaffBanner from "../ones/StaffBanner";

export default function View(props) {

	const appContext = useContext(AppContext);

	/* Place states here */
	const [ready, setReady] = useState(false);

	async function init() {
		// run initializations here
		setReady(false);
		// ..
		setReady(true);
	}

	useEffect(() => {
		init();
	}, []);

	if (ready) {
		return (
			<>
				<StaffBanner />
			</>
		);
	} else {
		return (
			<div className="container mSupportLoading">
				{getInlineLoader()}
			</div>
		);
	}
}
